import React from 'react'

const Backend = () => {
  return (
    <div className="skills_content">
        <h3 className="skills_title">Habilidades Baend </h3>

            <div className="skills_box">
               


                <div className="skills_group">
                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">node</h3>
                            <span className='skills_lavel'>Intermédio</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">php</h3>
                            <span className='skills_lavel'>Básico</span>
                        </div>
                    </div>

                    <div className="skills_data">
                        <i className="bx bx-badge-check"></i>

                        <div>
                            <h3 className="skills_name">MongoDB</h3>
                            <span className='skills_lavel'>Básico</span>
                        </div>
                    </div>


                    
                   
                </div>
            </div>
       
    </div>
  )
}

export default Backend